<template>
  <!-- ToDo 需要数据测试 -->
  <div>
    <van-nav-bar
      class="backBox"
      title="表扬奖励通知"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="message_box">
        <div class="top-text">
          <div class="top-text-hint">
            <div class="msgBeforeTit">上报时间：</div>
            <div class="msgAfterText">{{ createTime }}</div>
          </div>
          <div class="top-text-hint">
            <div class="msgBeforeTit">奖励通知：</div>
            <div class="msgAfterText">{{ awardNotice }}</div>
          </div>
          <div class="top-text-hint">
            <div class="msgBeforeTit">奖励结果：</div>
            <div class="msgAfterText">{{ awardResult }}</div>
          </div>
          <div class="top-text-hint">
            <div class="msgBeforeTit">奖励说明：</div>
            <div class="msgAfterText">{{ awardExplain }}</div>
          </div>
        </div>
        <!-- <div v-if="imgList && imgList.length > 0" class="img-list">
          <img
            v-for="(item, index) in imgList"
            class="img-list-item"
            :key="item.id"
            bindtap="preImage"
            :src="imgList[index]"
            mode="aspectFill"
          />
        </div> -->
        <div v-if="recordList && recordList.length > 0">
          <div class="text-list-title">练习记录</div>
          <div class="text-list">
            <div
              v-for="item in recordList"
              class="text-list-item"
              :key="item.id"
            >
              <div class="text-list-1">{{ item.date }}</div>
              <div class="text-list-2">{{ item.practice_time }}</div>
              <div class="text-list-3">{{ item.time_lag }}</div>
            </div>
          </div>
        </div>

        <!-- <div class="content-wrap">
          <div class="content-title">消息内容：</div>
          <span class="content-txt">{{ content }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import * as constant from '../../api/constant'

import { Toast, Dialog } from 'vant'
export default {
  data () {
    return {
      createTime: '',
      content: '',
      detailObj: {},
      type: '',
      id: '',
      award_punish_id: '',
      awardNotice: '',
      awardResult: '',
      awardExplain: '',
      recordList: []

    }
  },
  mounted () {
    this.detailObj = this.$route.query
    this.readMag(this.detailObj.id)
    this.getInfo()
  },
  computed: {

  },
  methods: {
    transformPunishText (info) {
      const dateStr = `${utils.formatTimeMDChinese(new Date(info.begin_time))} - ${utils.formatTimeMDChinese(new Date(info.end_time))}`
      if (info.type === constant.announceType.adminAward) {
        if (info.award_punish_type === 7) {
          return '系统点赞一次'
        } else if (info.award_punish_type === 1) {
          return `${dateStr}, ` + '每天奖励' + (Math.round(info.value / 60 * 100) / 100) + '个时长'
        } else {
          return `${dateStr}, ` + '奖励' + (Math.round(info.value / 60 * 100) / 100) + '个时长'
        }
      }
      return '-'
    },
    getInfo () {
      const para = {
        id: this.detailObj.id
      }

      let apiUrl = ''
      if (Number(this.detailObj.type) !== constant.announceType.adminAward) {
        Dialog.alert({
          title: '提示',
          message: '数据加载失败，点击确定后返回上一页'
        }).then(() => {
          // on close
          this.onClickLeft()
        })
      }
      apiUrl = 'adminAwardQuery'
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      api
        .axiosRequest(api.urlList[apiUrl], para)
        .then((res) => {
          Toast.clear()
          let createTime = ''
          if (res.code === common.resCode.OK) {
            createTime = utils.formatDate(res.create_time)

            let awardTypeText = ''
            if (Number(this.detailObj.type) === constant.announceType.adminAward) {
              awardTypeText = '表扬奖励通知'
            }
            this.awardNotice = awardTypeText
            this.awardResult = this.transformPunishText(res)
            this.awardExplain = res.content
            this.award_punish_id = res.award_punish_id
            this.createTime = utils.formatZHYMDHM(createTime)
            this.queryList()
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    queryList () {
      const para = {
        award_punish_id: this.award_punish_id
      }
      let apiMethod = ''
      if (Number(this.detailObj.type) === constant.announceType.adminAward) {
        apiMethod = 'adminAwardDetail'
      } else {
        return
      }
      api
        .axiosRequest(api.urlList[apiMethod], para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            const list = []
            const addTwoZero = function (c) {
              if (c < 10) {
                return '0' + c
              } else {
                return c
              }
            }
            if (!Array.isArray(res.list)) {
              return false
            }

            if (Number(this.detailObj.type) === constant.announceType.positive) {
              res.list.forEach(ite => {
                const bbTime = new Date(ite.book_begin_time)
                const beTime = new Date(ite.book_end_time)
                const newitem = {
                  date: bbTime.getFullYear() + '/' + addTwoZero(bbTime.getMonth() + 1) + '/' + addTwoZero(bbTime.getDate()),
                  appointment_time: addTwoZero(bbTime.getHours()) + ':' +
                    addTwoZero(bbTime.getMinutes()) + '-' +
                    addTwoZero(beTime.getHours()) + ':' +
                    addTwoZero(beTime.getMinutes()),
                  practice_time: '',
                  time_lag: '/'
                }
                let inTime, outTime
                if (ite.in_time) {
                  inTime = new Date(ite.in_time)
                  newitem.practice_time = addTwoZero(inTime.getHours()) + ':' + addTwoZero(inTime.getMinutes())
                }
                if (ite.in_time || ite.out_time) {
                  newitem.practice_time += '-'
                }
                if (ite.out_time) {
                  outTime = new Date(ite.out_time)
                  newitem.practice_time += addTwoZero(outTime.getHours()) + ':' + addTwoZero(outTime.getMinutes())

                  if (inTime) {
                    let dif = (outTime.getTime() - inTime.getTime()) / 1000
                    dif = (dif - dif % 60) / 60
                    newitem.time_lag = (dif >= 60 ? (Math.floor(dif / 60) + '小时') : '') +
                      (dif % 60 > 0 ? (dif % 60 + '分钟') : '')
                    if (!newitem.time_lag) {
                      newitem.time_lag = '0分钟'
                    }
                  }
                }

                if (!newitem.practice_time) {
                  newitem.practice_time = '/'
                }
                list.push(newitem)
              })
            }

            this.recordList = list
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    readMag () {
      const para = {
        announcement_id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.readMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .message_box {
  .top-text-hint{
    display: flex;
    // flex-shrink: 0;
}
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.9375rem;
    background-color: #fff;
    color: #666;

    .create-time {
      display: flex;
      align-items: center;
      font-size: 1rem;
      color: #666;
    }
    .content-wrap {
      margin-top: 0.625rem;
      display: flex;
    }

    .content-title {
      white-space: nowrap;
      font-size: 1rem;
      color: #666;
    }

    .content-txt {
      font-weight: 300;
      font-size: 1rem;
    }
  }
}
</style>
